import { useMutation } from '@tanstack/react-query';

import Note from '@components/ui/InfoNote';
import { callService } from '@api/remote-call';

import { HopiOption } from './Promotions';
import { MobileStyledButton, NoteWrapper, StyledFlexContainer } from './styled';

const ModalFooter = ({
  disabled,
  selectedPromotion,
  basketId = '',
  refetchBasket,
  closeModal,
}: {
  disabled: boolean;
  selectedPromotion?: HopiOption;
  basketId?: string;
  refetchBasket: () => void;
  closeModal: () => void;
}) => {
  const { mutate: switchOptions, isLoading } = useMutation(
    ['switchHopiOption', selectedPromotion, basketId],
    async () => {
      if (!selectedPromotion) return;
      return callService(
        { service: 'LoyaltiesService', method: 'switch', version: 'v3' },
        {
          basketId,
          body: selectedPromotion.variation,
          itemId: selectedPromotion.entityId,
        }
      );
    },
    {
      onSuccess: () => {
        refetchBasket();
        closeModal();
      },
      onError: () => {
        closeModal();
      },
    }
  );
  return (
    <StyledFlexContainer
      data-role='footer'
      alignItems='center'
      justifyContent='space-between'
      background='NL0'
    >
      <NoteWrapper>
        <Note
          backgroundColor='lightClearBlue'
          color='clearBlue'
          noMargin
          data-role='note'
        >
          Faydalanmak istediğiniz Hopi Kampanyasını seçiniz.
        </Note>
      </NoteWrapper>
      `
      <MobileStyledButton
        disabled={disabled || isLoading}
        size='large'
        onClick={() => switchOptions()}
        variant='Primary'
      >
        Uygula
      </MobileStyledButton>
    </StyledFlexContainer>
  );
};

export default ModalFooter;
